import { ProgressBarOverlayService } from '@shared/ui/progress-bar-overlay/progress-bar-overlay.service';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { ROUTER_REQUEST, ROUTER_NAVIGATED, ROUTER_CANCEL, ROUTER_ERROR } from '@ngrx/router-store';

@Injectable()
export class RouteEffects {
  private readonly progressBarOverlayService = inject(ProgressBarOverlayService);
  private readonly actions$ = inject(Actions);

  routeLoading$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(ROUTER_REQUEST),
        tap(() => this.progressBarOverlayService.show())
      );
    },
    { dispatch: false }
  );

  routeIdle$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(ROUTER_NAVIGATED, ROUTER_CANCEL, ROUTER_ERROR),
        tap(() => this.progressBarOverlayService.hide())
      );
    },
    { dispatch: false }
  );
}
